// extracted by mini-css-extract-plugin
export default {"root":"BaseWindowWin98_root__NqZZ7"};